export { DocumentCard } from './document-card';
export type { DocumentCardProps } from './document-card';
